import MoreVert from '@mui/icons-material/MoreVert'

const DeleteIcon = ({className}) => {
    const iconSelect = localStorage.getItem('iconsSelect')

    if (iconSelect === 'Custom') {
        return <MoreVert />
    }

    return (
        <MoreVert
            className={className}
            sx={{ display: 'flex', height: 20, margin: 'auto', width: 20 }}
        />
    )
}

export default DeleteIcon
